import template from './component.tpl.html';
import ContactConsumptionsComponentController from './controller';

angular
    .module('festzelt-os.modules.contacts')
    .component('contactConsumptions', {
        bindings: {
            contactId: '<'
        },
        controller: ContactConsumptionsComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/contacts/components/contact-consumptions/component.js